import { render } from "./VerifyLogin.vue?vue&type=template&id=4a583b93"
import script from "./VerifyLogin.vue?vue&type=script&lang=js"
export * from "./VerifyLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__